import api from '../token';

export const AlterUser = async (dados) => {
  try {
    const response = await api.post('/alterUser',dados);
    return response.data;
  } catch (error) {
    
    return [];
  }
};

